System.register(["./dyn-clsx.js", "./dyn-main.js", "./dyn-index.js", "./dyn-parallax-banner.js", "./dyn-index2.js"], function(exports, module) {
  "use strict";
  var jsxRuntimeExports, clsx, reactExports, j, useMobile, animate, scroll;
  return {
    setters: [(module2) => {
      jsxRuntimeExports = module2.j;
      clsx = module2.c;
    }, (module2) => {
      reactExports = module2.r;
      j = module2.j;
    }, (module2) => {
      useMobile = module2.u;
    }, (module2) => {
      animate = module2.a;
    }, (module2) => {
      scroll = module2.s;
    }],
    execute: function() {
      exports("default", ScrollAndHover);
      const MainWrapper = j("div")`
  width: 100vw;
  margin: 0 auto;
  margin-bottom: 25vh;

  video {
    position: absolute;
    pointer-events: none;
    left: 50%;
    top: 50vh;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
    transform-origin: center center;
    transform: translateX(-50%) translateY(-50%) scale(1.75);
    z-index: ${0};
  }

  @media screen and (max-width: 767px) {
    overflow-x: hidden;
    margin-bottom: 0;

    video {
      transform: none;
    }
  }

  .section-heading {
    top: 80px;
    position: relative;
    font-weight: 700;
    font-size: 80px;
    line-height: 120%;
    z-index: ${8};
    opacity: 0;
    transition: opacity .3s ease;

    @media screen and (max-width: 767px) {
      font-size: 32px;
      opacity: 1;
      top: 0;
      margin-bottom: -32px;
    }
  }

  .video-container {
    position: sticky;
    top: 0;
    max-width: 1280px;
    margin: 0 auto;
    aspect-ratio: 16 / 9;
    width: 100vw;
    height: auto;
    @media screen and (max-width: 767px) {
      aspect-ratio: initial;
    }
  }

  .hover-content--item {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s ease-in;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &.active {
      opacity: 1;
      background: rgba(0, 0, 0, 0.6);
      backdrop-filter: blur(15px);
    }
    &[data-trigger="left"] {
      --inner-padding: 0 24px 0 50px;
      padding-left: 50%;
      clip-path: polygon(50% 0, 100% 0, 100% 100%, 50% 100%);
    }
    &[data-trigger="right"] {
      --inner-padding: 0 50px 0 24px;
      padding-right: 50%;
      clip-path: polygon(0 0, 50% 0, 50% 100%, 0 100%);
    }

    @media screen and (max-width: 767px) {
      height: auto;
      position: relative;
      flex: 1 1 50%;
      padding-left: 0 !important;
      padding-right: 0 !important;
      clip-path: none !important;
      background: linear-gradient(180deg, #181B22 0%, #000000 100%);

      &[data-trigger="left"] {
        --inner-padding: 0 18px 0 32px;
      }
      &[data-trigger="right"] {
        --inner-padding: 0 32px 0 18px;
      }
    }

    h5 {
      font-size: 24px;
      font-weight: 600;
      line-height: 1.3;
      @media screen and (max-width: 767px) {
        font-size: 14px;
        font-weight: 600;
        line-height: 1.3;
      }
    }

    h6, h6 + div {
      padding-left: 30px;
      @media screen and (max-width: 767px) {
        padding-left: 16px;
      }
    }

    h6 + div {
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      color: rgba(255, 255, 255, 0.6);
      @media screen and (max-width: 767px) {
        display: none;
      }
    }

    h6 {
      position: relative;
      font-size: 18px;
      font-weight: 700;
      svg {
        display: block;
        position: absolute;
        left: 0;
        top: 5px;
        width: 19px;
        height: 14px;
        background-image: attr(data-icon);
      }
      @media screen and (max-width: 767px) {
        font-weight: 400;
        font-size: 12px;
        line-height: 1.2;
        svg {
          width: 12px;
          height: 10px;
          top: 2px;
        }
      }
    }
  }
  .hover-content--item-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: var(--inner-padding);
    @media screen and (max-width: 767px) {
      height: auto;
    }
  }
  .hover-content--item-features {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 28px;
    margin-top: 24px;
    @media screen and (max-width: 767px) {
      grid-template-columns: 1fr;
      gap: 14px 24px;
      margin-top: 20px;
    }
  }
  .hover-content {
    display: none;
    position: absolute;
    top: 50vh;
    width: 100%;
    height: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: ${5};
    @media screen and (max-width: 767px) {
      display: flex;
      position: relative;
      top: 0;
      left: 0;
      transform: none;
      height: auto;
      padding-top: 18px;
    }
  }
  .video-container.enabled {
    .section-heading {
      opacity: 1;
    }
    .hover-content {
      display: block;
    }
  }
`;
      function ScrollAndHover(props) {
        const {
          section_id
        } = props;
        const ref = reactExports.useRef(null);
        const [activeItem, setActiveItem] = reactExports.useState();
        const isMobile = useMobile();
        const [isHoverEnabled, setHoverEnabled] = reactExports.useState(false);
        const onMouseOver = reactExports.useCallback((evt) => {
          const currentTarget = evt.currentTarget;
          if (!currentTarget) return;
          const trigger = currentTarget.dataset.trigger;
          setActiveItem(trigger);
        }, []);
        const onMouseOut = reactExports.useCallback((evt) => {
          const currentTarget = evt.currentTarget;
          if (!currentTarget) return;
          const trigger = currentTarget.dataset.trigger;
          setActiveItem((state) => state === trigger ? void 0 : state);
        }, []);
        reactExports.useEffect(() => {
          if (ref.current) {
            if (isMobile) return;
            const root = ref.current;
            const template = document.querySelector(`#shopify-section-${section_id} template`);
            const videoContainer = ref.current.querySelector(".video-container");
            if (template) {
              videoContainer.appendChild(template.content.cloneNode(true));
            }
            const video = root.querySelector("video");
            const animation = animate(video, {
              transform: "translateX(-50%) translateY(-50%) scale(1)"
            }, {
              duration: 5e3,
              autoplay: false
            });
            if (video) {
              let resolve = () => {
              };
              let isReady = false;
              const readyPromise = new Promise((r) => resolve = r).then(() => isReady = true);
              video.addEventListener("loadedmetadata", () => resolve());
              video.addEventListener("canplaythrough", () => resolve());
              let cachedProgress = 0;
              const SPEED_RATE = 1.25;
              const update = async (p) => {
                if (isReady) {
                  const speedUp = Math.min(1, p * SPEED_RATE);
                  setHoverEnabled(speedUp >= 1);
                  const currentTime = speedUp * video.duration;
                  animation.time = speedUp * animation.duration;
                  video.currentTime = currentTime;
                } else {
                  cachedProgress = p;
                }
              };
              readyPromise.then(() => {
                update(cachedProgress);
              });
              const unlisten = scroll(update, {
                target: ref.current,
                offset: ["start start", "end end"],
                axis: "y"
              });
              return () => {
                var _a;
                (_a = video.parentElement) == null ? void 0 : _a.removeChild(video);
                animation.stop();
                unlisten();
              };
            }
          }
        }, [isMobile]);
        return /* @__PURE__ */ jsxRuntimeExports.jsx(MainWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref, style: isMobile ? {} : {
          height: "200vh"
        }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: clsx("video-container", {
          enabled: isHoverEnabled
        }), children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: clsx("section-heading"), children: props.heading }),
          isMobile ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: props.image, style: {
            width: "100%",
            height: "auto"
          } }) }) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: clsx("hover-content"), children: ["left", "right"].map((trigger, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: clsx("hover-content--item", {
            active: isMobile || activeItem === ["left", "right"][1 - index]
          }), "data-trigger": trigger, onMouseOver, onMouseOut, onClick: () => {
          }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: clsx("hover-content--item-inner"), children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: props.items[index].title }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: clsx("hover-content--item-features"), children: props.items[index].features.map((feature, index2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("h6", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "19", height: "14", viewBox: "0 0 19 14", fill: "none", version: "1.1", xmlns: "http://www.w3.org/2000/svg", dangerouslySetInnerHTML: {
                  __html: `<path d="M 18.97 1.35 C 18.86 1.07 18.51 0.92 18.2 1.05 C 15.76 2.04 12.71 4.7 10.78 7.27 C 10.7 7.38 10.53 7.39 10.43 7.31 C 9.39 6.39 8.54 5.67 7.51 4.97 C 7.13 4.71 6.59 4.75 6.25 5.05 L 5.14 6.02 C 4.95 6.19 4.95 6.46 5.14 6.63 C 5.31 6.78 5.57 6.8 5.77 6.69 L 6.02 6.54 C 6.03 6.54 6.04 6.54 6.04 6.54 C 7.12 7.51 8.35 8.9 9.44 10.72 C 9.63 11.02 10.09 11.09 10.39 10.87 C 10.81 10.56 11.37 10.2 11.78 10.04 C 11.91 9.99 12.03 9.91 12.1 9.79 C 12.96 8.29 14.07 6.65 15.25 5.23 C 16.42 3.81 17.65 2.61 18.73 1.95 C 18.95 1.82 19.06 1.57 18.97 1.35 Z" fill="#35EBFF" /> <path fill-rule="evenodd" clip-rule="evenodd" d="M 16 6.69 V 12 C 16 12.55 15.55 13 15 13 H 4 C 3.45 13 3 12.55 3 12 V 2 C 3 1.45 3.45 1 4 1 H 15 C 15.06 1 15.12 1 15.17 1.01 C 15.51 0.79 15.84 0.57 16.18 0.38 C 15.85 0.14 15.44 0 15 0 H 4 C 2.9 0 2 0.9 2 2 V 12 C 2 13.1 2.9 14 4 14 H 15 C 16.1 14 17 13.1 17 12 V 5.49 C 16.8 5.71 16.6 5.95 16.4 6.19 C 16.27 6.35 16.13 6.52 16 6.69 Z" fill="white" />`
                } }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: feature.title })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: {
                __html: feature.desc
              } })
            ] }, index2)) })
          ] }) }, trigger)) })
        ] }) }) });
      }
    }
  };
});
